import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "ui/theme";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import "helpers/formats";
import reportWebVitals from "./reportWebVitals";
import store from "./rootStore";
import AppInit from "app/App/components/AppInit";
import "ui/CountrySelect/freakflags.css";

// import "react-day-picker/dist/style.css";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    // <React.StrictMode>
    <BrowserRouter>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AppInit />
            </ThemeProvider>
        </Provider>
    </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
